export default __webpack_public_path__ + "static/media/BB_46.dc7bcd22.png";